export abstract class ConfigurationAbstract {

    protected getDataAttributeFor(name: string, element: HTMLScriptElement): string {
        const data = element.getAttribute(name);

        if (!data) {
            throw new Error(`${name} attribute missing on ${element.src} script!`);
        }

        element.removeAttribute(name);

        return data;
    }

}
